'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _wrapCombineReducers = require('../wrapCombineReducers');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

exports.default = function (Service, reducerName) {
  var mapTargets = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var dispatchableServices = {};
  var $ = (0, _wrapCombineReducers.createExternalActions)(reducerName);
  (0, _keys2.default)(Service).forEach(function (serviceName) {
    dispatchableServices[serviceName] = function (args) {
      return (0, _extends3.default)({
        external: $,
        target: mapTargets[serviceName] || serviceName,
        service: Service[serviceName],
        payload: args
      }, Service[serviceName]);
    };
  });
  return dispatchableServices;
};